<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="changVisible"
      title="通过SI系统导入信息"
      center
      width="746px"
      :before-close="$onClose"
      destroy-on-close
    >
      <!-- <h4>通过SI系统导入信息</h4> -->
      <div class="body">
        <div class="left">
          <div>按学号单个导入</div>
          <div>按年级批量导入</div>
          <!-- <div>按年级更新cGpa和学位等级数据</div> -->
        </div>
        <div class="middle">
          <div>
            <el-input
              class="input"
              size="mini"
              onkeyup="value=value.replace(/[^a-zA-Z0-9]/g,'')"
              v-model="stuNo"
              placeholder="输入学号"
            ></el-input>
            <span class="text">学号</span>
          </div>
          <div>
            <el-date-picker
              class="input"
              size="mini"
              value-format="yyyy"
              v-model="year"
              type="year"
              　:picker-options="pickerOptions"
              placeholder="请选择"
            >
            </el-date-picker>
            <span class="text">入学年份</span>
          </div>
        </div>
        <div class="right">
          <div>
            <el-button size="mini" type="primary" @click="verifyNum()"
              >导入</el-button
            >
          </div>
          <div>
            <el-button size="mini" type="primary" @click="verifyGrade()"
              >按照年级导入</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { URL_PATH } from "@/config/config";
import * as StrUtils from "@/utils/strUtils.js";
import * as CApi from "@/api/constant_api.js";
import * as Api from "@/api/api.js";
export default {
  data() {
    return {
      URL_PATH: URL_PATH,
      changVisible: false,
      title: "",
      stuNo: "",
      year: "",

      pickerOptions: {
        // 限制时间
        disabledDate(time) {
          let minYear = 2005;
          return (
            time > Date.now() ||
            time.getTime() < new Date(JSON.stringify(minYear))
          );
        },
      },
    };
  },
  methods: {
    $onClose(done) {
      done();
    },
    //页面初始化时加载的事件
    init() {
      this.changVisible = true;
      this.stuNo = "";
      this.year = "";
    },
    // 验证导入学号接口
    verifyNum() {
      Api.verifyApi(CApi.api_updateStudentOne, (verify) => {
        if (verify) {
          this.importNum();
        }
      });
    },
    // 验证导入年级接口
    verifyGrade() {
      Api.verifyApi(CApi.api_updateStudentsByYear, (verify) => {
        if (verify) {
          this.importGrade();
        }
      });
    },
    // 学号导入
    importNum() {
      if (StrUtils.isEmpty(this.stuNo)) {
        this.$message.error("请输入学号");
        return;
      }
      this.$api
        .updateStudentOne({
          token: localStorage.getItem("token"),
          student_no: this.stuNo,
        })
        .then(({ data }) => {
          console.log(data);
          this.changVisible = false;
          this.$emit("toOpLogList");
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
    // 年级导入
    importGrade() {
      if (StrUtils.isEmpty(this.year)) {
        this.$message.error("请选择入学年份");
        return;
      }
      this.$api
        .updateStudentsByYear({
          token: localStorage.getItem("token"),
          year: this.year,
        })
        .then(({ data }) => {
          this.changVisible = false;
          this.$emit("toOpLogList");
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.body {
  margin-top: 20px;
  overflow: hidden;
  background-color: #ffffff;
}
.left {
  width: 33%;
  float: left;
}
.left div,
.middle div,
.right div {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 40px;
}
.middle .text {
  float: right;
  margin-right: 10px;
}
.middle {
  width: 33%;
  float: left;
  overflow: hidden;
}
.right {
  width: 33%;
  float: left;
}
.right div {
  float: left;
  margin-left: 80px;
}
.input {
  float: right;
  width: 130px;
}
</style>

 <style lang="less" scoped>
.el-button--mini,
.el-button--mini.is-round {
  padding: 7px 15px;
  height: 28px;
}
</style>
 <style lang="less">
.right span {
  visibility: visible;
  float: right;
  line-height: 0px;
  margin-right: 0px;
}
/* element样式重置 start */
/* 去掉input尾部上下小箭头 start */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  appearance: none !important;
  margin: 0;
}
input[type="number"] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  -o-appearance: textfield;
  -ms-appearance: textfield;
  appearance: textfield;
}
/* 去掉input尾部上下小箭头 end */
</style>



// WEBPACK FOOTER //
// src/components/dialog/importSiDialog.vue